export const colors = {
  primary: '#0099FF',
  secondary: '#0099FF',
  gray10: '#EDF2F7',
  gray50: '#E6E4E3',
  gray100: '#7E7E7E',
  gray200: '#575756',
  lightRed: '#FF4238',
  red: '#db2828',
  yellow: '#fbbd08',
  orange: '#f2711c',
  lightGreen: '#4DE3B6',
  green: '#48BB78',
  white: '#fff',
  black: '#000',
  transparent: 'transparent',
};
